import { apiClient } from './client';
import type { ApiResponse, PaginatedResponse, Template, TemplateType } from '@/types/api.types';

export const templatesApi = {
  list: (params?: { page?: number; pageSize?: number; type?: TemplateType; isActive?: boolean }) =>
    apiClient.get<PaginatedResponse<Template>>('/templates', { params }),

  get: (id: string) =>
    apiClient.get<ApiResponse<Template>>(`/templates/${id}`),

  create: (data: { name: string; type: TemplateType; content: unknown; zenviaTemplateId?: string }) =>
    apiClient.post<ApiResponse<Template>>('/templates', data),

  update: (
    id: string,
    data: { name?: string; type?: TemplateType; content?: unknown; zenviaTemplateId?: string | null; isActive?: boolean },
  ) => apiClient.patch<ApiResponse<Template>>(`/templates/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/templates/${id}`),

  syncFromZenvia: () =>
    apiClient.post<ApiResponse<{ imported: number; updated: number; removed: number }>>('/templates/sync-from-zenvia'),
};
